const einvoicing = {
  // ==================== E-INVOICING ====================
  'einvoicing.title': 'E-Invoicing',
  'einvoicing.subtitle': 'Digitally capture, verify and match incoming invoices with purchase orders',
  'einvoicing.inDevelopmentDesc': 'The E-Invoicing module will enable digital capture and processing of incoming invoices, automatic matching with purchase orders and goods receipts, and forwarding into the approval process.',

  // Navigation
  'einvoicing.navDashboard': 'Dashboard',
  'einvoicing.navInbox': 'Inbox',
  'einvoicing.navOutbound': 'Outbox',
  'einvoicing.navCoverage': 'Countries & Formats',

  // Dashboard
  'einvoicing.kpiNeedsAction': 'Needs action',
  'einvoicing.kpiValidationFailed': 'Validation failed',
  'einvoicing.kpiDueSoon': 'Due within 7 days',
  'einvoicing.kpiOutboundOpen': 'Outbox open',
  'einvoicing.dashVolume': 'Document volume (12 months)',
  'einvoicing.dashFunnel': 'Inbound status overview',
  'einvoicing.dashRegimes': 'Country coverage',
  'einvoicing.dashRecent': 'Recent activity',
  'einvoicing.dashEmpty': 'No documents yet.',
  'einvoicing.dashLoadError': 'Could not load dashboard',
  'einvoicing.funnelInProcess': 'In process',
  'einvoicing.funnelError': 'Errors / rejected',
  'einvoicing.funnelComplete': 'Complete',
  'einvoicing.inbound': 'Inbound',
  'einvoicing.outbound': 'Outbound',
  'einvoicing.loading': 'Loading …',

  // List
  'einvoicing.searchPlaceholder': 'Search number or partner …',
  'einvoicing.allStates': 'All states',
  'einvoicing.needsActionOnly': 'Needs action only',
  'einvoicing.uploadButton': 'Upload invoice',
  'einvoicing.listEmpty': 'No invoices found.',
  'einvoicing.listLoadError': 'Could not load list',
  'einvoicing.uploadOk': 'Invoice imported ({format})',
  'einvoicing.uploadError': 'Upload failed',
  'einvoicing.uploadValidationFailed': 'Imported with {n} validation errors — please review',
  'einvoicing.colNumber': 'Number',
  'einvoicing.colCounterparty': 'Partner',
  'einvoicing.colIssueDate': 'Invoice date',
  'einvoicing.colDueDate': 'Due',
  'einvoicing.colAmount': 'Amount',
  'einvoicing.colFormat': 'Format',
  'einvoicing.colStatus': 'Status',
  'einvoicing.colMatch': 'Match',
  'einvoicing.noNumber': '(no number)',

  // Business state (track 1)
  'einvoicing.state.received': 'Received',
  'einvoicing.state.validated': 'Validated',
  'einvoicing.state.validation_failed': 'Validation failed',
  'einvoicing.state.in_approval': 'In approval',
  'einvoicing.state.approved': 'Approved',
  'einvoicing.state.rejected': 'Rejected',
  'einvoicing.state.posted_to_sap': 'Posted to SAP',
  'einvoicing.state.archived': 'Archived',
  'einvoicing.state.draft': 'Draft',
  'einvoicing.state.generated': 'Generated',
  'einvoicing.state.sent': 'Sent',

  // Transport state (track 2)
  'einvoicing.transport.received': 'Received',
  'einvoicing.transport.delivered': 'Delivered',
  'einvoicing.transport.submitted': 'Submitted',
  'einvoicing.transport.upo_received': 'UPO received',
  'einvoicing.chip.business': 'Business status (workflow)',
  'einvoicing.chip.transport': 'Transport/authority status',

  // Match
  'einvoicing.match.matched': 'PR matched',
  'einvoicing.match.partial': 'Partial (review)',
  'einvoicing.match.no_match': 'No PR found',
  'einvoicing.match.unavailable': 'Matching unavailable',

  // Detail
  'einvoicing.seller': 'Seller',
  'einvoicing.buyer': 'Buyer',
  'einvoicing.vatId': 'VAT ID',
  'einvoicing.orderRef': 'Order reference',
  'einvoicing.buyerRef': 'Buyer reference (routing ID)',
  'einvoicing.linePos': 'Pos.',
  'einvoicing.lineName': 'Description',
  'einvoicing.lineQty': 'Quantity',
  'einvoicing.linePrice': 'Unit price',
  'einvoicing.lineVat': 'VAT',
  'einvoicing.lineTotal': 'Net',
  'einvoicing.totalNet': 'Total net',
  'einvoicing.totalVat': 'VAT amount',
  'einvoicing.totalPayable': 'Amount payable',
  'einvoicing.files': 'Files (original = legal artifact)',
  'einvoicing.fileKind.original': 'Original',
  'einvoicing.fileKind.generated': 'Generated',
  'einvoicing.fileKind.validation-report': 'Validation report',
  'einvoicing.fileKind.attachment': 'Attachment',
  'einvoicing.retentionUntil': 'Retain until',
  'einvoicing.pdfView': 'PDF view',
  'einvoicing.pdfShow': 'Show',
  'einvoicing.pdfHide': 'Hide',
  'einvoicing.pdfViewNote': 'Visual copy — the machine-readable XML is the legally authoritative document. The generated PDF envelope is not yet PDF/A-3 certified.',
  'einvoicing.actions': 'Actions',
  'einvoicing.approve': 'Approve',
  'einvoicing.reject': 'Reject',
  'einvoicing.commentPlaceholder': 'Comment (required for rejection) …',
  'einvoicing.rejectNeedsComment': 'Rejection requires a comment.',
  'einvoicing.approvedMsg': 'Invoice approved',
  'einvoicing.rejectedMsg': 'Invoice rejected',
  'einvoicing.postToSap': 'Post to SAP (MM-LIV)',
  'einvoicing.postedMsg': 'Posted to SAP',
  'einvoicing.sapDocNo': 'SAP document no.',
  'einvoicing.generate': 'Generate',
  'einvoicing.generatedMsg': 'File generated and archived',
  'einvoicing.markSent': 'Mark as sent',
  'einvoicing.sentMsg': 'Marked as sent',
  'einvoicing.validation': 'Validation',
  'einvoicing.validationOk': 'Core validation passed',
  'einvoicing.validationCoreNote': 'portal core rules; official Schematron check follows via sidecar',
  'einvoicing.matching': 'PR matching',
  'einvoicing.rematch': 'Re-run matching',
  'einvoicing.timeline': 'History',

  // Events
  'einvoicing.event.received': 'Invoice received',
  'einvoicing.event.validation_passed': 'Validation passed',
  'einvoicing.event.validation_failed': 'Validation failed',
  'einvoicing.event.matched': 'PR matching executed',
  'einvoicing.event.approved': 'Approved',
  'einvoicing.event.rejected': 'Rejected',
  'einvoicing.event.posted_to_sap': 'Posted to SAP',
  'einvoicing.event.sap_post_failed': 'SAP posting failed',
  'einvoicing.event.draft_created': 'Draft created',
  'einvoicing.event.generated': 'File generated',
  'einvoicing.event.sent': 'Sent',

  // Outbound
  'einvoicing.sapBillingDocs': 'SAP billing documents (adapter)',
  'einvoicing.sapBillingDocsHint': "Source: SAP adapter seam (mock today, Konstantin's real adapter later). Pick a document → portal draft → generate format.",
  'einvoicing.createDraft': 'Create draft',
  'einvoicing.draftCreatedMsg': 'Outbound draft created',

  // Countries & formats
  'einvoicing.coverageTitle': 'Regime coverage (8 countries)',
  'einvoicing.coverageHint': 'Verified = legal basis confirmed by adversarially verified research (as of 07/2026). Unverified regimes: no compliance commitments.',
  'einvoicing.covCountry': 'Country',
  'einvoicing.covModel': 'Model',
  'einvoicing.covFormats': 'Formats',
  'einvoicing.covChannels': 'Channels',
  'einvoicing.covSigning': 'Signing',
  'einvoicing.covArchive': 'Retention',
  'einvoicing.covStatus': 'Legal status',
  'einvoicing.covMandates': 'Obligations & dates',
  'einvoicing.years': 'years',
  'einvoicing.regimeVerified': 'verified',
  'einvoicing.regimeUnverified': 'UNVERIFIED',
  'einvoicing.signing.none': 'none (internal control procedure)',
  'einvoicing.signing.session': 'session auth (certificate)',
  'einvoicing.signing.per-invoice-b2g': 'B2G: qualified signature per file',
  'einvoicing.signing.platform': 'platform (PA) carries compliance',
  'einvoicing.signing.verifactu-records': 'hash chain + QR (Verifactu)',
  'einvoicing.signing.unknown': 'unclear',

  // Plant (Werk)
  'einvoicing.plant': 'Plant',
  'einvoicing.allPlants': 'All plants',
  'einvoicing.colPlant': 'Plant',
  'einvoicing.plantUnassigned': '— unassigned —',
  'einvoicing.plantSetMsg': 'Plant assigned',
  'einvoicing.event.plant_set': 'Plant assigned',
};

export default einvoicing;
